import { render, staticRenderFns } from "./BindCard1.vue?vue&type=template&id=e0c595e6&scoped=true&"
import script from "./BindCard1.vue?vue&type=script&lang=js&"
export * from "./BindCard1.vue?vue&type=script&lang=js&"
import style0 from "./BindCard1.vue?vue&type=style&index=0&id=e0c595e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0c595e6",
  null
  
)

export default component.exports